export default function getNumberOfCards(isDesktop: boolean) {
  const containerWidth = typeof window !== "undefined" ? window.innerWidth : 0;
  const averageCardWidth = isDesktop ? 410 : 330;
  const newSlidesToShow = Math.max(containerWidth / averageCardWidth, 1);

  return isDesktop ? 3 : newSlidesToShow;
}
